export const PRODUCT_TYPE_TC = "TC";
export const BENEFICIARY_VALIDATION_PREVIEW_ACTIVITIES = ["transfers.foreign.preview", "transfers.local.preview"];
